export const questionNames = {
    Section: "Section",
    ShortContactData: "ShortContactData",
    ContactData: "ContactData",
    Availability: "Availability",
    ExpectedSalary: "ExpectedSalary",
    ExpectedSalaryUsd: "ExpectedSalaryUsd",
    ExpectedSalaryEur: "ExpectedSalaryEur",
    ExpectedSalaryUah: "ExpectedSalaryUah",
    Dropdown: "Dropdown",
    RadioButton: "RadioButton",
    AddFile: "AddFile",
    TextBox: "TextBox",
    MultiCheckbox: "Checkbox",
    Multiselect: "Multiselect",
    Languages: "Languages",
    DriverLicense: "DriverLicense",
    DatePicker: "Date",
    PersonalData2: "PersonalData2",
    RecommendingPerson: "RecommendingPerson",
    CvFile: "CvFile",
    Clauses: "Clauses",
    Consents: "Consents",
} as const;
